// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-html-preview[data-v-5fafddc7]{max-width:175px;max-height:230px;padding:0;overflow:hidden}.card-html-preview__wrapper[data-v-5fafddc7]{width:600px;height:930px;overflow-y:hidden;transform:scale(.25);transform-origin:0 0}.card-html-preview__wrapper__iframe[data-v-5fafddc7]{width:100%;height:100%;border:0}", ""]);
// Exports
module.exports = exports;
